import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { INgProductTour } from '@libs/frameworks/angular';

import { MASCOT_IMG_LINKS } from '../../../../../../assets';
import { EnumSidebarPage } from '../../../../../components/layout/sidebar/sidebar-pages.interface';


//** Enums -------------------------------------- */
export enum EnumUploadTourElement {
	AppToggleBtn 		   	   	= 'product_tour_app_toggle_btn',
	AddDesigns 					= 'product_tour_add_designs',
	PodDownloadLinks			= 'product_tour_pod_download_links',
	PodTutorials 				= 'product_tour_pod_tutorials',
	DummyDomElement 			= 'dummy_dom_element'
}


@Injectable({
	providedIn: 'root'
})
export class ProductTourUpload {

	//** Configurations */
	private readonly MASCOT_IMG_LINKS: typeof MASCOT_IMG_LINKS = MASCOT_IMG_LINKS;

	constructor(
		private router: Router
	) {}


	/**------------------------------------------------------
	 * Upload Tour
	 */
	readonly PRODUCT_TOUR_UPLOAD: INgProductTour = {
		showTourProgressBullets	: true,
		showCloseButton	 		: true,
		hooks 		 			: {
			onStart 	 		: () => {},
			onClose 	 		: () => {},
			onComplete 	 		: () => this.router.navigateByUrl('/')
		},
		tourSteps 				: [
			{
				id		 		: EnumUploadTourElement.AppToggleBtn,
				pageUrl 		: '/',
				hint 	 		: {
					title 	 	: `Let's do Upload 🙏`,
					message  	: 'Up here you can get to Flying Upload. When you are on the upload section the icon will take you back to the research.'
				}
			},
			{
				id		 		: EnumSidebarPage.UploadMenuPod,
				pageUrl 		: '/',
				hint 	 		: {
					title 	 	: 'Print On Demand',
					message  	: 'This section includes your Design Management, the Edit, and much more. Simply select what you want to do.'
				}
			},
			{
				id		 		: EnumSidebarPage.UploadPodDesignManagement,
				pageUrl 		: '/upload/pod/design-management',
				hint 	 		: {
					title 	 	: 'Design Management',
					message  	: 'This is the Design Management, here you can add new designs, do all the design related work, and much more.'
				}
			},
			{
				id		 		: EnumUploadTourElement.AddDesigns,
				pageUrl 		: '/upload/pod/design-management',
				hint 	 		: {
					title 	 	: 'Add Designs',
					message  	: 'By using the "Add Designs" button, you can import your designs into the application (yes even listings from excel sheets).'
				}
			},
			{
				id		 		: EnumSidebarPage.UploadPodEdit,
				pageUrl 		: '/upload/pod/edit',
				hint 	 		: {
					title 	 	: 'Edit',
					message  	: 'Within the Edit page you can create your listings and edit the data of your designs. It is pretty advanced, so make sure to watch the tutorial first.'
				}
			},
			{
				id		 		: EnumSidebarPage.UploadMenuUpload,
				pageUrl 		: '/upload/setup-pod-uploader',
				hint 	 		: {
					title 	 	: 'Upload',
					message  	: 'Here you will find the uploader (the upload automation tool). Please make sure to watch the tutorials on the pages first, before downloading the application.'
				}
			},
			{
				id		 		: EnumUploadTourElement.PodDownloadLinks,
				pageUrl 		: '/upload/setup-pod-uploader',
				hint 	 		: {
					title 	 	: 'Pod Download Links',
					message  	: 'The uploader is a desktop application. Using these links, you can download the upload tool either for "Windows" or "macOS".'
				}
			},
			{
				id		 		: EnumSidebarPage.Tutorials,
				pageUrl 		: '/tutorials',
				hint 	 		: {
					title 	 	: 'Tutorials',
					message 	: 'The tutorial section provides all necessary lessons for the tools and pages which we have in this application. Here you will also learn how to configure and use the upload automation.'
				}
			},
			{
				id				: EnumUploadTourElement.DummyDomElement,
				pageUrl 		: '/tutorials/tutorial-pod-upload',
				hint			: {
					title   	: 'Congratulations 🎉',
					message 	: 'You have successfully completed the Upload Tour. Consider taking the Research Tour as well.',
					image 		: this.MASCOT_IMG_LINKS.HAPPY
				}
			}
		]
	};
}
